import { P as Popup, p as popupDefinition } from './definition65.js';
import { I as Icon, i as iconDefinition } from './definition28.js';
import { D as DOM, V as VividElement, o as observable, a as attr, h as html, d as createRegisterFunction, f as defineVividComponent } from './vivid-element.js';
import { g as keyHome, d as keyEnd, e as keyArrowUp, f as keyArrowDown, h as keyArrowLeft, i as keyArrowRight, a as keySpace, k as keyEnter } from './key-codes.js';
import { b as AffixIcon, a as affixIconTemplateFactory } from './affix.js';
import { a as applyMixins } from './apply-mixins.js';
import { D as Direction, g as getDirection } from './direction.js';
import { A as Anchored, a as anchorSlotTemplateFactory } from './anchored.js';
import { D as DelegatesAria } from './delegates-aria.js';
import { i as isHTMLElement } from './dom.js';
import { h as handleEscapeKeyAndStopPropogation } from './index.js';
import { r as ref } from './ref.js';
import { c as classNames } from './class-names.js';
import { s as slotted, e as elements } from './slotted.js';
import { w as when } from './when.js';

const styles$1 = ":host(:focus-visible){outline:none}:host([disabled]){pointer-events:none}.base{--_appearance-color-text: var(--_connotation-color-firm);--_appearance-color-fill: transparent;--_appearance-color-outline: transparent}.base:where(.hover,:hover):where(:not(.disabled,:disabled,.readonly)){--_appearance-color-text: var(--_connotation-color-firm);--_appearance-color-fill: var(--_connotation-color-faint);--_appearance-color-outline: transparent}.base:where(.disabled,:disabled){--_appearance-color-text: var(--vvd-color-neutral-300);--_appearance-color-fill: transparent;--_appearance-color-outline: transparent}.base:where(.active,:active):where(:not(.disabled,:disabled)){--_appearance-color-text: var(--_connotation-color-firm);--_appearance-color-fill: var(--_connotation-color-soft);--_appearance-color-outline: transparent}.base:where(.selected):where(:not(.disabled,:disabled)){--_appearance-color-text: var(--_connotation-color-firm);--_appearance-color-fill: var(--_connotation-color-soft);--_appearance-color-outline: transparent}.base:where(.selected):where(.hover,:hover):where(:not(.disabled,:disabled,.readonly)){--_appearance-color-text: var(--_connotation-color-firm);--_appearance-color-fill: var(--_connotation-color-dim);--_appearance-color-outline: transparent}.base.connotation-cta{--_connotation-color-primary: var(--vvd-menu-item-cta-primary, var(--vvd-color-cta-500));--_connotation-color-primary-text: var(--vvd-menu-item-cta-primary-text, var(--vvd-color-canvas));--_connotation-color-primary-increment: var(--vvd-menu-item-cta-primary-increment, var(--vvd-color-cta-600));--_connotation-color-firm: var(--vvd-menu-item-cta-firm, var(--vvd-color-cta-600));--_connotation-color-faint: var(--vvd-menu-item-cta-faint, var(--vvd-color-cta-50));--_connotation-color-soft: var(--vvd-menu-item-cta-soft, var(--vvd-color-cta-100));--_connotation-color-pale: var(--vvd-menu-item-cta-pale, var(--vvd-color-cta-300));--_connotation-color-dim: var(--vvd-menu-item-cta-dim, var(--vvd-color-cta-200))}.base:not(.connotation-cta){--_connotation-color-primary: var(--vvd-menu-item-accent-primary, var(--vvd-color-canvas-text));--_connotation-color-primary-text: var(--vvd-menu-item-accent-primary-text, var(--vvd-color-canvas));--_connotation-color-primary-increment: var(--vvd-menu-item-accent-primary-increment, var(--vvd-color-neutral-800));--_connotation-color-firm: var(--vvd-menu-item-accent-firm, var(--vvd-color-canvas-text));--_connotation-color-faint: var(--vvd-menu-item-accent-faint, var(--vvd-color-neutral-50));--_connotation-color-soft: var(--vvd-menu-item-accent-soft, var(--vvd-color-neutral-100));--_connotation-color-pale: var(--vvd-menu-item-accent-pale, var(--vvd-color-neutral-300));--_connotation-color-dim: var(--vvd-menu-item-accent-dim, var(--vvd-color-neutral-200))}.base{display:flex;box-sizing:border-box;align-items:center;background-color:var(--_appearance-color-fill);box-shadow:inset 0 0 0 1px var(--_appearance-color-outline);inline-size:100%}.base:not(.two-lines){gap:12px;min-block-size:calc(1px*(40 + 4*clamp(-1,var(--vvd-size-density, 0),2)));padding-block:8px;padding-inline:12px}.base.two-lines{padding:12px;gap:16px;min-block-size:calc(1px*(40 + 4*clamp(-1,var(--vvd-size-density, 0),2)) + 1px*(24 + 4*clamp(-1,var(--vvd-size-density, 0),2)))}@supports (user-select: none){.base{user-select:none}}.base:not(.disabled){cursor:pointer}:host(:not([role=presentation]):focus-visible) .base{box-shadow:inset 0 0 0 3px var(--focus-stroke-gap-color, currentColor);outline:2px solid var(--focus-stroke-color, var(--vvd-color-canvas-text));outline-offset:calc(-2px - var(--focus-inset, 0px));--focus-stroke-gap-color: transparent}.icon{flex-shrink:0;font-size:calc(1px*(40 + 4*clamp(-1,var(--vvd-size-density, 0),2))/2);line-height:1}.action,.decorative{display:flex;place-content:center}.action{color:var(--_appearance-color-text)}.base.trailing .action,.base.has-meta .action{order:2}:host(:not([check-appearance],[aria-checked=true],[disabled])) .action{color:var(--vvd-color-neutral-500)}.base:not(.disabled) .decorative{color:var(--vvd-color-neutral-600)}.base.disabled .decorative{color:var(--vvd-color-neutral-200)}.base.has-meta .decorative{order:1}.chevron{order:3}.text{display:flex;overflow:hidden;flex-direction:column;gap:4px;margin-inline-end:auto}.text-primary,.text-secondary{display:-webkit-box;overflow:hidden;-webkit-box-orient:vertical;font:var(--vvd-typography-base)}.text-primary{font:var(--vvd-typography-base);-webkit-line-clamp:var(--text-primary-line-clamp, 1)}.base:not(.disabled) .text-primary{color:var(--vvd-color-canvas-text)}.base.disabled .text-primary{color:var(--_appearance-color-text)}.base.two-lines .text-primary{font:var(--vvd-typography-base-bold)}.text-secondary{color:var(--vvd-color-neutral-800);font:var(--vvd-typography-base-condensed);-webkit-line-clamp:var(--text-secondary-line-clamp, 1)}.base.two-lines .text-secondary{color:var(--vvd-color-neutral-600)}.base.disabled .text-secondary{color:var(--_appearance-color-text)}.base.selected:not(.disabled) .text-secondary{color:var(--vvd-color-neutral-800)}";

const MenuItemRole = {
  menuitem: "menuitem",
  menuitemcheckbox: "menuitemcheckbox",
  menuitemradio: "menuitemradio",
  presentation: "presentation"
};
const roleForMenuItem = {
  [MenuItemRole.menuitem]: "menuitem",
  [MenuItemRole.menuitemcheckbox]: "menuitemcheckbox",
  [MenuItemRole.menuitemradio]: "menuitemradio",
  [MenuItemRole.presentation]: "presentation"
};

var __defProp$1 = Object.defineProperty;
var __decorateClass$1 = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp$1(target, key, result);
  return result;
};
const _Menu = class _Menu extends Anchored(DelegatesAria(VividElement)) {
  constructor() {
    super(...arguments);
    this.expandedItem = null;
    /**
     * The index of the focusable element in the items array
     * defaults to -1
     */
    this.focusIndex = -1;
    /**
     * if focus is moving out of the menu, reset to a stable initial state
     * @internal
     */
    this.handleFocusOut = (e) => {
      if (!this.contains(e.relatedTarget) && this.menuItems !== void 0 && this.menuItems.length) {
        this.collapseExpandedItem();
        const focusIndex = this.menuItems.findIndex(
          this.isFocusableElement
        );
        this.menuItems[this.focusIndex].setAttribute("tabindex", "-1");
        this.menuItems[focusIndex].setAttribute("tabindex", "0");
        this.focusIndex = focusIndex;
      }
    };
    this.handleItemFocus = (e) => {
      const targetItem = e.target;
      if (this.menuItems !== void 0 && targetItem !== this.menuItems[this.focusIndex]) {
        this.menuItems[this.focusIndex].setAttribute("tabindex", "-1");
        this.focusIndex = this.menuItems.indexOf(targetItem);
        targetItem.setAttribute("tabindex", "0");
      }
    };
    this.handleExpandedChanged = (e) => {
      const changedItem = e.target;
      if (this.expandedItem !== null && changedItem === this.expandedItem && changedItem.expanded === false) {
        this.expandedItem = null;
      }
      if (changedItem.expanded) {
        this.expandedItem = changedItem;
      }
    };
    this.removeItemListeners = () => {
      if (this.menuItems !== void 0) {
        this.menuItems.forEach((item) => {
          item.removeEventListener("expanded-change", this.handleExpandedChanged);
          item.removeEventListener(
            "focus",
            this.handleItemFocus
          );
        });
      }
    };
    this.setItems = () => {
      const newItems = this.domChildren();
      this.removeItemListeners();
      this.menuItems = newItems;
      const menuItems = this.menuItems.filter(this.isMenuItemElement);
      if (menuItems.length) {
        this.focusIndex = 0;
      }
      menuItems.forEach((item, index) => {
        item.setAttribute("tabindex", index === 0 ? "0" : "-1");
        item.addEventListener("expanded-change", this.handleExpandedChanged);
        item.addEventListener("focus", this.handleItemFocus);
      });
    };
    /**
     * check if the item is a menu item
     */
    this.isMenuItemElement = (el) => {
      return isHTMLElement(el) && Object.prototype.hasOwnProperty.call(
        _Menu.focusableElementRoles,
        el.getAttribute("role")
      );
    };
    /**
     * check if the item is focusable
     */
    this.isFocusableElement = (el) => {
      return this.isMenuItemElement(el);
    };
    this.placement = "bottom";
    this.autoDismiss = false;
    this.positionStrategy = "fixed";
    this.open = false;
    this.#onAnchorClick = () => {
      if (this.#triggerBehaviour === "off") {
        return;
      }
      if (this.#triggerBehaviour === "legacy" && this.open) {
        return;
      }
      const newValue = !this.open;
      DOM.queueUpdate(() => this.open = newValue);
    };
    this._onFocusout = (e) => {
      const focusTarget = e.relatedTarget;
      const focusMovedAway = !this.contains(focusTarget) && !this._anchorEl?.contains(focusTarget);
      if (this.autoDismiss && focusMovedAway) {
        this.open = false;
      }
    };
  }
  /**
   * @internal
   */
  itemsChanged() {
    if (this.$fastController.isConnected && this.menuItems !== void 0) {
      this.setItems();
    }
  }
  static {
    this.focusableElementRoles = roleForMenuItem;
  }
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback();
    DOM.queueUpdate(() => {
      this.setItems();
    });
  }
  /**
   * @internal
   */
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeItemListeners();
    this.menuItems = void 0;
  }
  /**
   * Moves focus into the menu. If there is a child with the `autofocus` attribute, it will be focused.
   * Otherwise, the first focusable child will be focused.
   *
   * @public
   */
  focus() {
    const autoFocusElement = this.querySelector(
      '[autofocus]:not([slot="anchor"])'
    );
    if (autoFocusElement instanceof HTMLElement) {
      autoFocusElement.focus();
    } else {
      this.setFocus(0, 1);
    }
  }
  /**
   * Collapses any expanded Menu Items.
   *
   * @public
   */
  collapseExpandedItem() {
    if (this.expandedItem !== null) {
      this.expandedItem.expanded = false;
      this.expandedItem = null;
    }
  }
  /**
   * @internal
   */
  handleMenuKeyDown(e) {
    if (e.defaultPrevented || this.menuItems === void 0) {
      return;
    }
    switch (e.key) {
      case keyArrowDown:
        this.setFocus(this.focusIndex + 1, 1);
        return;
      case keyArrowUp:
        this.setFocus(this.focusIndex - 1, -1);
        return;
      case keyEnd:
        this.setFocus(this.menuItems.length - 1, -1);
        return;
      case keyHome:
        this.setFocus(0, 1);
        return;
      default:
        return true;
    }
  }
  /**
   * get an array of valid DOM children
   */
  domChildren() {
    return Array.from(this.children).filter((child) => !child.hasAttribute("hidden")).filter((child) => !child.hasAttribute("slot"));
  }
  setFocus(focusIndex, adjustment) {
    if (this.menuItems === void 0) {
      return;
    }
    while (focusIndex >= 0 && focusIndex < this.menuItems.length) {
      const child = this.menuItems[focusIndex];
      if (this.isFocusableElement(child)) {
        if (this.focusIndex > -1 && this.menuItems.length >= this.focusIndex - 1) {
          this.menuItems[this.focusIndex].setAttribute("tabindex", "-1");
        }
        this.focusIndex = focusIndex;
        child.setAttribute("tabindex", "0");
        child.focus();
        break;
      }
      focusIndex += adjustment;
    }
  }
  get #triggerBehaviour() {
    return this.trigger ?? "legacy";
  }
  openChanged(_, newValue) {
    if (newValue) {
      this._popupEl?.show().then(() => this.focus());
    }
    newValue ? this.$emit("open", void 0, { bubbles: false }) : this.$emit("close", void 0, { bubbles: false });
    if (this._anchorEl) {
      this.#updateAnchor(this._anchorEl);
    }
  }
  /**
   * @internal
   */
  _anchorElChanged(oldValue, newValue) {
    if (oldValue) this.#cleanupAnchor(oldValue);
    if (newValue) this.#setupAnchor(newValue);
  }
  #setupAnchor(a) {
    a.addEventListener("click", this.#onAnchorClick, true);
    a.addEventListener("focusout", this._onFocusout);
    a.setAttribute("aria-haspopup", "menu");
    this.#updateAnchor(a);
  }
  #updateAnchor(a) {
    a.setAttribute("aria-expanded", this.open.toString());
  }
  #cleanupAnchor(a) {
    a.removeEventListener("click", this.#onAnchorClick, true);
    a.removeEventListener("focusout", this._onFocusout);
    a.removeAttribute("aria-haspopup");
    a.removeAttribute("aria-expanded");
  }
  #onAnchorClick;
  /**
   * @internal
   */
  _onChange(e) {
    if (this.menuItems === void 0) {
      return;
    }
    const clickedOnNonCheckboxMenuItem = e.target instanceof HTMLElement && (e.target.role === "menuitem" || e.target.role === "menuitemradio");
    if (this.#triggerBehaviour === "auto" && clickedOnNonCheckboxMenuItem) {
      this.open = false;
    }
    const changedMenuItem = e.target;
    const changeItemIndex = this.menuItems.indexOf(changedMenuItem);
    if (changeItemIndex === -1) {
      return;
    }
    if (changedMenuItem.role === "menuitemradio" && changedMenuItem.checked) {
      for (let i = changeItemIndex - 1; i >= 0; --i) {
        const item = this.menuItems[i];
        const role = item.getAttribute("role");
        if (role === MenuItemRole.menuitemradio) {
          item.checked = false;
        }
        if (role === "separator") {
          break;
        }
      }
      const maxIndex = this.menuItems.length - 1;
      for (let i = changeItemIndex + 1; i <= maxIndex; ++i) {
        const item = this.menuItems[i];
        const role = item.getAttribute("role");
        if (role === MenuItemRole.menuitemradio) {
          item.checked = false;
        }
        if (role === "separator") {
          break;
        }
      }
    }
    return true;
  }
};
__decorateClass$1([
  observable
], _Menu.prototype, "items");
__decorateClass$1([
  attr({ mode: "fromView" })
], _Menu.prototype, "placement");
__decorateClass$1([
  attr
], _Menu.prototype, "trigger");
__decorateClass$1([
  attr({ mode: "boolean", attribute: "auto-dismiss" })
], _Menu.prototype, "autoDismiss");
__decorateClass$1([
  attr({ mode: "fromView", attribute: "position-strategy" })
], _Menu.prototype, "positionStrategy");
__decorateClass$1([
  attr({ mode: "boolean" })
], _Menu.prototype, "open");
__decorateClass$1([
  observable
], _Menu.prototype, "headerSlottedContent");
__decorateClass$1([
  observable
], _Menu.prototype, "actionItemsSlottedContent");
let Menu = _Menu;

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
var CheckAppearance = /* @__PURE__ */ ((CheckAppearance2) => {
  CheckAppearance2["Normal"] = "normal";
  CheckAppearance2["TickOnly"] = "tick-only";
  return CheckAppearance2;
})(CheckAppearance || {});
class MenuItem extends VividElement {
  constructor() {
    super();
    // eslint-disable-next-line @nrwl/nx/workspace/no-attribute-default-value
    this.role = MenuItemRole.menuitem;
    this.hasSubmenu = false;
    this.currentDirection = Direction.ltr;
    /**
     * @internal
     */
    this.handleMenuItemClick = (e) => {
      if (e.defaultPrevented || this.disabled) {
        return false;
      }
      this.invoke();
      return false;
    };
    /**
     * @internal
     */
    this.handleMouseOver = (_) => {
      if (this.disabled || !this.hasSubmenu || this.expanded) {
        return false;
      }
      this.expanded = true;
      return false;
    };
    /**
     * @internal
     */
    this.handleMouseOut = (_) => {
      if (!this.expanded || this.contains(document.activeElement)) {
        return false;
      }
      this.expanded = false;
      return false;
    };
    this.invoke = () => {
      if (this.disabled) {
        return;
      }
      switch (this.role) {
        case MenuItemRole.menuitemcheckbox:
          this.checked = !this.checked;
          break;
        case MenuItemRole.menuitem:
          this.updateSubmenu();
          if (this.hasSubmenu) {
            this.expanded = true;
          } else {
            this.$emit("change");
          }
          break;
        case MenuItemRole.menuitemradio:
          if (!this.checked) {
            this.checked = true;
          }
          break;
      }
    };
    this.checkTrailing = false;
    this.#submenuArray = [];
    /**
     * @internal
     */
    this.handleMenuItemKeyDown = (e) => {
      if (e.defaultPrevented) {
        return false;
      }
      switch (e.key) {
        case keyEnter:
        case keySpace:
          this.invoke();
          if (!this.disabled) {
            this.#emitSyntheticClick();
          }
          return false;
        case keyArrowRight:
          if (this.hasSubmenu) {
            this.expanded = true;
            this.#emitSyntheticClick();
          }
          return false;
        case keyArrowLeft:
          if (this.expanded) {
            this.#emitSyntheticClick();
            this.expanded = false;
            this.focus();
            return false;
          }
      }
      return true;
    };
    this.#syntheticClickEvents = /* @__PURE__ */ new WeakSet();
    this.addEventListener("expanded-change", this.#expandedChange);
  }
  /**
   * @internal
   */
  expandedChanged() {
    if (this.$fastController.isConnected) {
      if (this.submenu === void 0) {
        return;
      }
      if (this.expanded === false) {
        this.submenu.collapseExpandedItem();
      } else {
        this.currentDirection = getDirection(this);
      }
      this.$emit("expanded-change", this, { bubbles: false });
    }
  }
  /**
   * @internal
   */
  checkedChanged() {
    if (this.$fastController.isConnected) {
      this.$emit("change");
    }
  }
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback();
    DOM.queueUpdate(() => {
      this.updateSubmenu();
    });
    this.observer = new MutationObserver(this.updateSubmenu);
  }
  /**
   * @internal
   */
  disconnectedCallback() {
    super.disconnectedCallback();
    this.submenu = void 0;
    if (this.observer !== void 0) {
      this.observer.disconnect();
      this.observer = void 0;
    }
  }
  #submenuArray;
  /**
   *
   *
   * @internal
   */
  slottedSubmenuChanged(_oldValue, newValue) {
    this.#submenuArray = newValue;
  }
  updateSubmenu() {
    for (const submenu of this.#submenuArray) {
      this.submenu = submenu;
      this.submenu.anchor = this;
      this.submenu.placement = "right-start";
      this.submenu.collapseExpandedItem = () => this.#collapseExpandedItem();
    }
    this.hasSubmenu = this.submenu === void 0 ? false : true;
  }
  #collapseExpandedItem() {
    this.expanded = false;
  }
  #expandedChange() {
    if (this.hasSubmenu) {
      this.submenu.open = this.expanded;
    }
  }
  #syntheticClickEvents;
  /**
   * @internal
   */
  _isSyntheticClickEvent(event) {
    return this.#syntheticClickEvents.has(event);
  }
  #emitSyntheticClick() {
    const mouseEvent = new MouseEvent("click", {
      bubbles: true,
      composed: true
    });
    this.#syntheticClickEvents.add(mouseEvent);
    this.dispatchEvent(mouseEvent);
  }
}
__decorateClass([
  attr({ mode: "boolean" })
], MenuItem.prototype, "disabled");
__decorateClass([
  attr({ mode: "boolean" })
], MenuItem.prototype, "expanded");
__decorateClass([
  attr
], MenuItem.prototype, "role");
__decorateClass([
  attr({ mode: "boolean" })
], MenuItem.prototype, "checked");
__decorateClass([
  observable
], MenuItem.prototype, "hasSubmenu");
__decorateClass([
  observable
], MenuItem.prototype, "currentDirection");
__decorateClass([
  observable
], MenuItem.prototype, "submenu");
__decorateClass([
  attr
], MenuItem.prototype, "text");
__decorateClass([
  attr({ attribute: "text-secondary" })
], MenuItem.prototype, "textSecondary");
__decorateClass([
  attr
], MenuItem.prototype, "connotation");
__decorateClass([
  attr({ mode: "boolean", attribute: "check-trailing" })
], MenuItem.prototype, "checkTrailing");
__decorateClass([
  attr({ attribute: "check-appearance" })
], MenuItem.prototype, "checkedAppearance");
__decorateClass([
  observable
], MenuItem.prototype, "metaSlottedContent");
__decorateClass([
  observable
], MenuItem.prototype, "trailingMetaSlottedContent");
__decorateClass([
  observable
], MenuItem.prototype, "slottedSubmenu");
applyMixins(MenuItem, AffixIcon);

const getIndicatorIcon = (x) => {
  if (x.checkedAppearance === CheckAppearance.TickOnly) {
    return x.checked ? "check-line" : "";
  }
  const iconType = x.role === MenuItemRole.menuitemcheckbox ? "checkbox" : "radio";
  const iconStatus = x.checked ? "checked" : "unchecked";
  return `${iconType}-${iconStatus}-2-line`;
};
const getClasses$1 = ({
  connotation,
  disabled,
  checked,
  role,
  text: text2,
  textSecondary,
  icon,
  metaSlottedContent,
  checkTrailing
}) => classNames(
  "base",
  [`connotation-${connotation}`, Boolean(connotation)],
  ["disabled", Boolean(disabled)],
  ["selected", role !== MenuItemRole.menuitem && Boolean(checked)],
  [
    "trailing",
    role !== MenuItemRole.menuitem && (checkTrailing || Boolean(icon))
  ],
  ["item-checkbox", role === MenuItemRole.menuitemcheckbox],
  ["item-radio", role === MenuItemRole.menuitemradio],
  ["two-lines", Boolean(text2?.length) && Boolean(textSecondary?.length)],
  ["has-meta", Boolean(metaSlottedContent?.length)]
);
function handleClick(x, { event }) {
  if (x._isSyntheticClickEvent(event)) {
    return true;
  }
  x.handleMenuItemClick(event);
  return x.role === MenuItemRole.presentation;
}
function checkIndicator(context) {
  const iconTag = context.tagFor(Icon);
  return html`${when(
    (x) => x.role === MenuItemRole.menuitemcheckbox || x.role === MenuItemRole.menuitemradio,
    html`<span class="action"><${iconTag} class="icon" name="${(x) => getIndicatorIcon(x)}"></${iconTag}></span>`
  )}`;
}
function text() {
  return html`${when(
    (x) => x.text || x.textSecondary,
    html`<span class="text">
			${when(
      (x) => x.text,
      html`<span class="text-primary">${(x) => x.text}</span>`
    )}
			${when(
      (x) => x.textSecondary,
      html`<span class="text-secondary">${(x) => x.textSecondary}</span>`
    )}
		</span>`
  )}`;
}
const MenuItemTemplate = (context) => {
  const affixIconTemplate = affixIconTemplateFactory(context);
  const iconTag = context.tagFor(Icon);
  return html`
		<template
			role="${(x) => x.role ? x.role : MenuItemRole.menuitem}"
			aria-haspopup="${(x) => x.hasSubmenu ? "menu" : void 0}"
			aria-checked="${(x) => x.role !== MenuItemRole.menuitem ? x.checked : void 0}"
			aria-disabled="${(x) => x.disabled}"
			aria-expanded="${(x) => x.expanded}"
			@keydown="${(x, c) => x.handleMenuItemKeyDown(c.event)}"
			@click="${handleClick}"
			@mouseover="${(x, c) => x.handleMouseOver(c.event)}"
			@mouseout="${(x, c) => x.handleMouseOut(c.event)}"
		>
			<div class="${getClasses$1}">
				<slot name="meta" ${slotted("metaSlottedContent")}></slot>
				${checkIndicator(context)}
				${when(
    (x) => x.icon,
    html`<span class="decorative"
						>${(x) => affixIconTemplate(x.icon)}</span
					>`
  )}
				${text()}
				<slot
					name="trailing-meta"
					${slotted("trailingMetaSlottedContent")}
				></slot>
				${when(
    (x) => x.hasSubmenu,
    html`<${iconTag} class="chevron" name="chevron-right-line"></${iconTag}>`
  )}
			</div>
			<slot
				name="submenu"
				${slotted({
    property: "slottedSubmenu",
    filter: elements(context.tagForNonDependency(menuName))
  })}
			></slot>
		</template>
	`;
};

const menuItemDefinition = defineVividComponent(
  "menu-item",
  MenuItem,
  MenuItemTemplate,
  [iconDefinition],
  {
    styles: styles$1
  }
);
const registerMenuItem = createRegisterFunction(menuItemDefinition);

const styles = ":host{display:var(--_popup-display, inline)}:host([slotted-anchor]){--_popup-display: contents}.base{display:flex;overflow:hidden auto;box-sizing:border-box;flex-direction:column;gap:8px;inline-size:max-content;max-block-size:var(--menu-block-size, 408px);min-inline-size:var(--menu-min-inline-size);padding-block:8px}@media not all and (width >= 600px){.base{max-inline-size:var(--menu-max-inline-size, 300px)}}@media (width >= 600px){.base{max-inline-size:var(--menu-max-inline-size)}}::slotted(a){color:var(--vvd-color-canvas-text);text-decoration:none}::slotted(a[role=menuitem]:focus-visible){box-shadow:inset 0 0 0 3px var(--focus-stroke-gap-color, currentColor);outline:2px solid var(--focus-stroke-color, var(--vvd-color-canvas-text));outline-offset:calc(-2px - var(--focus-inset, 0px));--focus-stroke-gap-color: transparent;display:block}.header{padding-block-start:4px;padding-inline:12px}.hide-header .header{display:none}.body{display:flex;flex-direction:column;row-gap:1px}.hide-body .body{display:none}.action-items{display:flex;justify-content:flex-end;gap:8px;padding-block-end:4px;padding-inline:12px}.hide-actions .action-items{display:none}";

const getClasses = ({
  headerSlottedContent,
  actionItemsSlottedContent,
  items
}) => classNames(
  "base",
  ["hide-header", !headerSlottedContent?.length],
  ["hide-actions", !actionItemsSlottedContent?.length],
  ["hide-body", items && !items.length]
);
function handleEscapeKey(menu, event) {
  if (menu.open && handleEscapeKeyAndStopPropogation(event)) {
    menu.open = false;
  }
  return true;
}
const MenuTemplate = (context) => {
  const popupTag = context.tagFor(Popup);
  const anchorSlotTemplate = anchorSlotTemplateFactory();
  function handlePopupEvents(x, e, state) {
    e.stopPropagation();
    x.open = state;
  }
  return html`
		<template role="presentation"
							@change="${(x, c) => x._onChange(c.event)}"
							@focusout="${(x, c) => x._onFocusout(c.event)}">
			${anchorSlotTemplate}
			<${popupTag}
				${ref("_popupEl")}
				:placement=${(x) => x.placement}
				:open=${(x) => x.open}
				:anchor=${(x) => x._anchorEl}
				:strategy="${(x) => x.positionStrategy}"
				@keydown="${(x, c) => handleEscapeKey(x, c.event)}"
				@vwc-popup:open="${(x, c) => handlePopupEvents(x, c.event, true)}"
				@vwc-popup:close="${(x, c) => handlePopupEvents(x, c.event, false)}"
			>
			<div class="${getClasses}">
				<div class="header">
					<slot name="header" ${slotted("headerSlottedContent")}></slot>
				</div>
				<div
					class="body"
					role="menu"
					aria-label="${(x) => x.ariaLabel}"
					@keydown="${(x, c) => x.handleMenuKeyDown(c.event)}"
					@focusout="${(x, c) => x.handleFocusOut(c.event)}"
				>
					<slot ${slotted("items")}></slot>
				</div>
				<footer class="action-items"><slot name="action-items"  ${slotted(
    "actionItemsSlottedContent"
  )}></slot></footer>
			</div>
		</${popupTag}>
	</template>`;
};

const menuName = "menu";
const menuDefinition = defineVividComponent(
  menuName,
  Menu,
  MenuTemplate,
  [popupDefinition, menuItemDefinition],
  {
    styles
  }
);
const registerMenu = createRegisterFunction(menuDefinition);

export { MenuItem as M, MenuItemRole as a, menuName as b, menuDefinition as c, registerMenu as d, Menu as e, menuItemDefinition as m, registerMenuItem as r };
